import type { ReactElement } from 'react'
import { cn } from '../../lib/cn'

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  /** Announced to assistive tech. Say what is loading, not "loading". */
  label?: string
}

const SIZES = { sm: 14, md: 18, lg: 24 } as const

/**
 * An indeterminate arc. Under `prefers-reduced-motion` the rotation stops and the arc
 * becomes a static ring — presence still communicates "working".
 */
export const Spinner = ({ size = 'md', className, label }: SpinnerProps): ReactElement => {
  const px = SIZES[size]
  return (
    <span className={cn('inline-flex items-center', className)} role="status" aria-live="polite">
      <svg
        width={px}
        height={px}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
        className="anim-spin"
      >
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.5" opacity="0.22" />
        <path
          d="M21 12a9 9 0 0 0-9-9"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      </svg>
      {label ? <span className="sr-only">{label}</span> : null}
    </span>
  )
}
